<template>
	<div>
		<div style="margin-bottom: 10px;">
			<span style="margin-left: 10px; margin-right: 40px;">时间</span>
			<el-date-picker v-model="filter.date" @change="getList()" type="daterange" size="small"
				style="margin-left: 10px;margin-right: 25px; width: 250px;" value-format="yyyy-MM-dd"
				range-separator="至">
			</el-date-picker>
			<span style="margin-left: 10px; margin-right: 40px;">发型师</span>
			<el-input v-model="filter.workerName" size="small" @change="filter.workerId = '',getList()" clearable
				placeholder="输入员工名称" style="width: 200px"></el-input>
			<el-button type="primary" size="mini" @click="getList()" style="margin-left: 10px;">筛选</el-button>
			<el-button type="primary" size="mini" @click="exportWorkerFileDetail()" style="float: right;">导出</el-button>
		</div>
		<el-table :data="list" v-loading="loading"
			:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D'}"
			:cell-style="{ 'text-align':'center'}">
			<el-table-column label="发型师">
				<template slot-scope="{row}">
					{{row.workerName}}
				</template>
			</el-table-column>
			<el-table-column label="日期">
				<template slot-scope="{row}">
					{{row.date}}
				</template>
			</el-table-column>
			<el-table-column label="门店">
				<template slot-scope="{row}">
					<!-- {{row.storeInfo}} -->
					<div v-for="item in row.storeInfo" :key="item.index">
						{{item.storeName}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="日销售">
				<template slot-scope="{row}">
					{{row.payTotal}}
				</template>
			</el-table-column>
			<el-table-column label="权益新/老客数">
				<template slot-scope="{row}">
					{{row.newMember}}/{{row.oldMember}}
				</template>
			</el-table-column>
			<el-table-column label="抖音双倍单数">
				<template slot-scope="{row}">
					{{row.douyinDouble}}
				</template>
			</el-table-column>
			<el-table-column label="剪发新/老客数">
				<template slot-scope="{row}">
					{{row.newHair}}/{{row.oldHair}}
				</template>
			</el-table-column>
			<el-table-column label="平均服务时长">
				<template slot-scope="{row}">
					{{row.avgServiceTime}}
				</template>
			</el-table-column>
			<el-table-column label="实际订单数">
				<template slot-scope="{row}">
					{{row.orderNum}}
				</template>
			</el-table-column>
			<el-table-column label="统计订单数">
				<template slot-scope="{row}">
					{{row.orderCount}}
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import {
		url
	} from "../../../utils/index.js"
	export default {
		data() {
			return {
				url: url(),
				list: [],
				filter: {
					date: '',
					workerName: "",
					workerId: ""
				},
				loading: false
			}
		},
		mounted() {
			const date0 = localStorage.getItem("month") + '-01'
			const date1 = localStorage.getItem("month") + '-31'
			this.filter.workerId = localStorage.getItem("workerId")
			this.filter.date = [date0, date1]
			this.getList()
		},
		methods: {
			getList() {
				this.loading = true
				var a = {}
				if (this.filter.date) {
					a.startTime = this.filter.date[0]
					a.endTime = this.filter.date[1]
				}
				if (this.filter.workerId != null && this.filter.workerId != '') {
					a.workerId = this.filter.workerId
				}
				if (this.filter.workerName != null && this.filter.workerName != '') {
					a.workerName = this.filter.workerName
					delete a.workerId
					this.filter.workerId = ''
				}
				this.$http.get("dWorkerFileDetail/findFileDetail", {
					params: a
				}, {
					emulateJSON: true
				}).then(res => {
					// if(res.status==200){
					this.list = res.body
					var list = res.body
					for (let i in list) {
						list[i].storeInfo = JSON.parse(list[i].storeInfo)
					}
					this.list = list
					// }
					this.loading = false
				})
			},
			exportWorkerFileDetail() {
				console.log(this.filter.date)
				let str = "dWorkerFileDetail/exportWorkerFileDetail" +
					"?startTime=" + this.filter.date[0] +
					"&endTime=" + this.filter.date[1]
				if (this.filter.workerId) {
					let workerId = "&workerId=" + this.filter.workerId
					str += workerId;
				}
				if (this.filter.workerName) {
					let workerName = "&workerName=" + this.filter.workerName
					str += workerName;
				}
				// if(this.filter.workerId?"&workerId="+this.filter.workerId:"&workerName="+this.filter.workerName);
				window.location.assign(this.url + str);
			}
		},
	};
</script>

<style>
</style>